module.exports = __webpack_public_path__ + "static/img/13.7ed666a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/13.png
// module id = +2PM
// module chunks = 0